import { queriesInternalAccounts, queriesPayrolls } from "@query";
import { WSEmptyState, WSGrid, WSList } from "@wingspanhq/fe-component-library";
import React from "react";

import { selectorActiveBankingAccount } from "../../../../shared/selectors/selectorActiveBankingAccount";
import { PayrollRunCard } from "../../components/PayrollRunCard";
import { RecentHistoryWidget } from "../../components/RecentHistoryWidget";
import { WalletBalanceCard } from "../../components/WalletBalanceCard";
import {
  PAYROLL_RUNS_ACTIVE_STATUSES,
  PAYROLL_RUNS_TYPE
} from "../../constants";
import {
  routeHelperPayrollRunsDashboardActivePayrolls,
  routeHelperPayrollRunsDetails
} from "../../paths";
import { selectorPayrollRunSummary } from "../../selectors/selectorPayrollRunSummary";
import { selectorPayrollRunsWalletBalance } from "../../selectors/selectorPayrollRunsWalletBalance";
import { PayrollRunsYear } from "../../types";
import { getPayrollRunYearDateRange } from "../../utils";

export const RoutePayrollRunsActivePayrolls: React.FC = () => {
  const {
    params: { year: yearParam }
  } = routeHelperPayrollRunsDashboardActivePayrolls.useData();
  const year = yearParam as PayrollRunsYear;

  const goToDetails = routeHelperPayrollRunsDetails.useGoTo();

  const queryPayrolls = queriesPayrolls.listPayrolls.useQueryAll({
    filter: {
      type: { eq: PAYROLL_RUNS_TYPE },
      payDate: getPayrollRunYearDateRange(year),
      status: { anyOf: PAYROLL_RUNS_ACTIVE_STATUSES }
    }
  });
  const payrollRuns = (queryPayrolls.flatData ?? []).map(
    selectorPayrollRunSummary
  );

  // Funding wallet + balance for the sidebar card.
  const queryInternalAccounts =
    queriesInternalAccounts.listInternalAccounts.useQuery();
  const fundingAccount = queryInternalAccounts.data?.data?.find(
    selectorActiveBankingAccount
  );
  const queryBalance =
    queriesInternalAccounts.getInternalAccountBalance.useQuery(
      { internalAccountId: fundingAccount?.id ?? "" },
      { enabled: !!fundingAccount?.id }
    );
  const walletBalance = selectorPayrollRunsWalletBalance({
    internalAccount: fundingAccount,
    balance: queryBalance.data
  });

  return (
    <WSGrid gutter="L" mt="L">
      <WSGrid.Item span={{ s: "12", l: "8" }}>
        {!queryPayrolls.isInitialLoading && payrollRuns.length === 0 ? (
          <WSEmptyState
            bgColor="gray"
            description="Active payroll runs for the selected year will appear here."
            hasBorder
            title="No active payrolls"
            type="documents"
          />
        ) : (
          <WSList gap="L">
            {payrollRuns.map(payrollRun => (
              <PayrollRunCard
                key={payrollRun.id}
                goToDetails={() => {
                  goToDetails({ year, payrollRunId: payrollRun.id });
                }}
                payrollRun={payrollRun}
              />
            ))}
          </WSList>
        )}
      </WSGrid.Item>

      <WSGrid.Item span={{ s: "12", l: "4" }}>
        <WSList gap="L">
          <WalletBalanceCard balance={walletBalance} />
          <RecentHistoryWidget />
        </WSList>
      </WSGrid.Item>
    </WSGrid>
  );
};
